import React, { useState } from "react";
import ICON_COPY from "../../assets/copy.svg";
import ICON_DONE from "../../assets/done.svg";

interface TypeCopyProps {
  text: string;
}

function copyToClipboard(text: string) {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  try {
    document.execCommand("copy");
  } catch (err) {
    console.error(err);
  }
  document.body.removeChild(textarea);
}

const Copy: React.FC<TypeCopyProps> = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    copyToClipboard(text);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };
  if (!text) return null;
  return (
    <img
      title="Copy"
      onClick={handleCopy}
      style={{ cursor: "pointer" }}
      alt={copied ? "Copied!" : "Copy"}
      src={copied ? ICON_DONE : ICON_COPY}
    />
  );
};

export default Copy;
